(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jarticle-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-jarticle-copy]');
    if (!button) return;

    var url = button.getAttribute('data-jarticle-copy');
    var done = function () {
      button.classList.add('is-copied');
      var label = button.getAttribute('data-copied-label');
      if (label) button.setAttribute('title', label);
      setTimeout(function () {
        button.classList.remove('is-copied');
      }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done);
      return;
    }

    var field = document.createElement('textarea');
    field.value = url;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
      done();
    } finally {
      document.body.removeChild(field);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
